import PropTypes from 'prop-types'

import * as S from './styled'

const RatingStars = ({ id, url }) => {
  return (
    <S.RatingStars>
      <span
        className="product-rating bv-widget-rating"
        data-bv-show="inline_rating"
        data-bv-product-id={id}
        data-bv-redirect-url={url}
      />
    </S.RatingStars>
  )
}

RatingStars.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string.isRequired
}

export default RatingStars
